import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';
import {properties} from '../../../environments/properties';

@Injectable({
    providedIn: 'root',
})
export class ParamService {
    bannerConfiguration: string;
    banner: string;
    capitalizedBanner: string;
    logoUrl: string;
    whiteLogoUrl: string;
    isUnifiedBanner = true;
    private banners = Object.keys(environment.bannerConfiguration);

    constructor() {
        this.banner = this.resolveBanner();
        this.capitalizedBanner = (properties.bannerConfiguration as any)[this.banner]?.banner;
        this.setLogoUrls();
    }
  
 
    // look through banner configurations and match with the hostname
    // if unable to match, default to safeway
    resolveBanner() {
        const curBanner = this.getBannerFromServerProps()
        if (curBanner) {
            return curBanner;
        }
        return 'safeway'
    }

    getBannerFromServerProps() {
      const bannerElement = document.getElementById('banner');
        
        if (bannerElement) {
            const bannerValue = bannerElement.getAttribute('data-banner');
            if (bannerValue) {
                return bannerValue;
            }
        }
        return null;
      }

    removeAbActiveOrderLocalStorage() { // remove only on order confrimation page
        // This condition should help the view order status modal #2854
        if (localStorage.getItem('abActiveOrders')) {
            localStorage.removeItem('abActiveOrders');
        }
    }

    getUnifiedContext() {
        return 'account';
    }

    setLogoUrls() {
        const baseUrl = '/content/dam/logos/';
        this.bannerConfiguration = environment.bannerConfiguration[this.banner];
        if ((this.bannerConfiguration
                && this.bannerConfiguration['logoUrls'])
            && (this.bannerConfiguration['logoUrls']['color']
                && this.bannerConfiguration['logoUrls']['white'])) {
            this.logoUrl = baseUrl + this.bannerConfiguration['logoUrls']['color'];
            this.whiteLogoUrl = baseUrl + this.bannerConfiguration['logoUrls']['white'];
        }
    }
}
